import { Box, styled } from '@mui/material';

export const LoginForm = styled(Box)({
  width: '100%',
  margin: 'auto',
  padding: '34px 24px',
  paddingBottom: '61px',
  zIndex: 99999999
});

export const LoginOptions = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '26px',
});
